import React, { useState } from "react";
import { Divider } from "antd";
import FilterSection from "../../modules/Dashboards/Booking/FilterSection";
import RenewalOverview from "../../modules/Dashboards/RenewalPipeline/RenewalOverview";
import BookingsList from "../../modules/Dashboards/Booking/BookingsList";
import DashboardLayout from "../../molecules/DashboardLayout";
const RenewalDashboard: React.FC = React.memo(() => {
  const [widgetAccess, setWidgetAccess]: any = useState();
  const [dashboardkey, setDashboardKey] = useState("renewals");
  return (
    <DashboardLayout>
      <div>
        <FilterSection
          setWidgetAccess={setWidgetAccess}
          setDashboardKey={setDashboardKey}
          dashboardkey={dashboardkey}
        />

        <Divider />

        <RenewalOverview widgetAccess={widgetAccess?.result} />

        {/* <BookingsList title="Renewal" /> */}
      </div>
    </DashboardLayout>
  );
});

export default RenewalDashboard;
